require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./physique-2-1-3-8.json") })
        }
      }, "path---physique-2-1-3-8");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---physique-2-1-3-8!./.cache/json/physique-2-1-3-8.json
// module id = 521
// module chunks = 231608221292675